import React from 'react';
import ReactDOM from 'react-dom';
// import 'moment-timezone';
import {  bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';
import * as Actions from '../../actions/Post';
import CommunityHeader from '../Community/CommunityHead'

import PostCard from './Card'
import jump from 'jump.js'

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      "post[content]": "",
      postCreateMode: false
    };
  };

  joinedCheck = () => {
    const circle = this.props.Community.community
    const currentUser = this.props.App.currentUser

    if (circle && currentUser) {
      if (circle.host.id === currentUser.id) {
        return true
      } else {
        const status = circle.joined_status
        if (status === 'approved') {
          return true
        } else {
          return false
        }
      }
    } else {
      return false
    }
  }

  checkAllEnter = () => {
    // 全入力チェック
    if (!!this.state['post[content]']) {
      return true
    } else {
      return false
    }
  }

  onSubmit = (e) => {
    e.preventDefault();

    const form = document.querySelector('.post-form')
    const formData = new FormData(e.target)
    if (this.props.method === 'update') {
      this.props.communitySave(formData, this.state["community[id]"])
    } else {
      this.props.postCreate(this.state['post[content]'], this.props.match.params.id)
    }
    document.querySelector('.postCreateField').blur()
    this.setState({ "post[content]": "" })
  }

  valueChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }


  componentDidMount = () => {
    this.fetchCircle()
  }

  fetchCircle = () => {
    const communityId = Number(this.props.match.params.id)
    if (!this.props.Community.community || Number(this.props.Community.community.id) !== communityId) {
      this.props.communityGetFromPost(communityId)
    }
  }

  componentWillMount = () => {
    this.fetchCircle()
  }

  componentWillUpdate = () => {
    this.fetchCircle()
  }

  componentWillUpdate = (nextProps) => {

  }

  componentDidUpdate = () => {
    const elm = document.querySelector('.postCreateFieldWrap.active')
    const header = document.getElementById('appHeader')
    if (this.state.postCreateMode && elm) {
      
      header.classList.add('panel-open')
      jump(elm, {
        duration: 200,
        offset: -50
      })
    } else {
      header.classList.remove('panel-open')
    }
  }

  componentWillReceiveProps = (nextProps) => {
    // this.fetchCircle(nextProps)
    // if (!!nextProps.Community.previewCommunity) {
    //   const { history } = this.props
    //   history.push(RT.COMMUNITY_PREVIEW_PATH.replace(/:id/, nextProps.Community.previewCommunity.id))
    // }
  }

  windowHeightFetch = () => {
    const mainObject = document.getElementById('panel')
    // ウインドウサイズ
    const windowHeight = document.documentElement.clientHeight;
    // mainタグの高さ
    const mainScrollHeight = mainObject.scrollHeight
    // ターゲット
    const targetCard = document.querySelector('.postCreateField')
    // ターゲットの相対的位置
    const targetOffsetTop = targetCard.offsetTop
    const HeaderHeight = document.querySelector('.circleHeader').scrollHeight
    // ターゲットの絶対位置
    const targetTop = targetOffsetTop + HeaderHeight
    const targetHeight = targetCard.clientHeight
    const targetBottomPosition = targetTop + targetHeight
    const targetBottomBlankHeight = mainScrollHeight - targetBottomPosition
    const needBlankHeight = windowHeight - targetHeight
    const canScroll = needBlankHeight <= targetBottomBlankHeight

    if (!canScroll) {
      mainObject.style.height = `${mainScrollHeight + (needBlankHeight - targetBottomBlankHeight + 50)}px`
    } else {
      mainObject.style.height = 'auto'
    }
  }

  postCreateFieldFocus = (e) => {
    // e.target.scrollIntoView({ block: 'start', behavior: 'smooth', inline: 'nearest' })
    // window.scrollTo(0, 300)
    // html.classList.add('slideout-open')
    this.windowHeightFetch()
    this.setState({ postCreateMode: true })
  }

  postCreateFieldBlur = (e) => {
    const html = window.document.documentElement;
    html.classList.remove('slideout-open')
    this.windowHeightFetch()
    this.setState({ postCreateMode: false })
  }

  render = () => {
    const currentUser = this.props.App.currentUser
    const currentPath = this.props.router.location.pathname

    let postsBody, posts, overlay
    if (!!this.props.Community.community) {
      posts = this.props.Community.community.posts
    }

    if (!!posts && posts.length > 0) {
      postsBody = posts.sort((a, b) => {
        const aDate = new Date(a.created_at)
        const bDate = new Date(b.created_at)
        const aNum = Math.round(aDate.getTime() / 1000)
        const bNum = Math.round(bDate.getTime() / 1000)
        if (aNum > bNum) return -1;
        if (aNum < bNum) return 1;
        return 0;
      }).map(post => {
        return (
          <PostCard post={post} key={post.id} currentUser={currentUser} updatePost={this.props.postUpdate} destroyPost={this.props.postDestroy} circle={this.props.Community.community} commentCreate={this.props.commentCreate} commentUpdate={this.props.commentUpdate} commentDestroy={this.props.commentDestroy} joined={this.joinedCheck()}/>
        )
      })
    } else {
      postsBody = (
        <p>投稿はまだありません。</p>
      )
    }
    if (this.state.postCreateMode) {
      overlay = (
        <div id='menuOverlay' onClick={this.toggleMenu} className='fadein' ></div>
      )
    }

    let postFormField
    if (this.joinedCheck()) {
      postFormField = (
        <textarea type='text' name='post[content]' onChange={this.valueChange} placeholder='気軽に投稿してみよう♪' className={'postCreateField' + (this.state.postCreateMode ? ' active' : '')} value={this.state["post[content]"]} onFocus={this.postCreateFieldFocus} onBlur={this.postCreateFieldBlur}></textarea>
      )
    }

    return (
      <section className='circleShow'>
        {(() => {
          if (this.state.postCreateMode) {
            return (
              ReactDOM.createPortal(overlay, document.getElementById('contentOverlayWrap'))
            )
          }
        })()}
        <CommunityHeader currentUser={currentUser} currentPath={currentPath} circle={this.props.Community.community} />
        <div className='pc-container'>
          <form className='post-form form' onSubmit={this.onSubmit} >
            <div className='row'>
              <div className={'field col-12 mb5 postCreateFieldWrap' + (this.state.postCreateMode ? ' active relative' : '')}>
                {postFormField}
                {(() => {
                  if (this.state.postCreateMode) {
                    if (this.checkAllEnter()) {
                      return (
                        <div className='mt5 mb15 col-12'>
                          <input type='submit' value='投稿' className='btn btn-white btn-bordered btn-block btn-submit' onMouseDown={this.onSubmit} />
                          <span className='btn btn-block btn-white' onClick={this.postCreateFieldBlur}>閉じる</span>
                        </div>
                      )
                    } else {
                      return (
                        <div className='mt5 mb15 col-12'>
                          <input type='submit' value='投稿' className='btn btn-white btn-bordered btn-block btn-submit disabled' disabled />
                          <span className='btn btn-block btn-white' onClick={this.postCreateFieldBlur}>閉じる</span>
                        </div>
                      )
                    }
                  }
                })()}
              </div>
              <div className='col-12'>
                {postsBody}
              </div>
            </div>
          </form>
        </div>

        
      </section>
    )
  }
}


const mapStateToProps = (state) => {
  return state
};

const mapDispatchToProps = (dispatch) => (bindActionCreators(Actions, dispatch));


const Container = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Component);

export default withRouter(Container);


// WEBPACK FOOTER //
// ./src/components/Post/Post.jsx